/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import React, { useState } from 'react';
import TabSideBar from '../tabSideBar/TabSideBar';
import { FlexBox } from '@ui5/webcomponents-react';
import { uiFullHeight } from '../../Styling/Theme/Theme';
import { UserSettings } from '../../types';
import { useSelector } from 'react-redux';
import { getTextKeyByLanguageCode } from '../../utils/langUtils';
import { useTranslations } from '../../hooks/useTranslations';
import { getItem } from '../../utils/storageUtils';
import LanguageRegion from '../languageRegion/LanguageRegion';
import Profile from '../profile/Profile';
import CrmAccountSelection from '../crmAccountSelection/CrmAccountSelection';

const Settings: React.FC = () => {
    const userSettings: UserSettings = useSelector((state: any) => state.productList.userSettings);
    const [activeTab, setActiveTab] = useState<number>(0);
    const { t } = useTranslations();
    const user = getItem('user');

    const tabs = [
        {
            icon: 'account',
            title: t('USER_ACCOUNT'),
            body: `${user?.given_name} ${user?.family_name}`,
            component: Profile,
        },
        {
            icon: 'globe',
            title: t('LANGUAGE_REGION'),
            body: t(getTextKeyByLanguageCode(userSettings.selectedLocal)),
            component: LanguageRegion,
        },
        {
            icon: 'company-view',
            title: t('CUSTOMER_ACCOUNT_TITLE'),
            body: `${t('CRM_ID')}: ${t(user.crm_account_id)}`,
            component: CrmAccountSelection,
        },
    ];

    return (
        <FlexBox style={{ height: uiFullHeight.height }}>
            <TabSideBar tabs={tabs} onTabSelect={setActiveTab} />
            <FlexBox style={{ flex: 1 }}>{React.createElement(tabs[activeTab].component as React.ComponentType)}</FlexBox>
        </FlexBox>
    );
};

export default Settings;
